module.exports = __webpack_public_path__ + "static/img/SRGLogo_white_2022.ab96a2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SRGLogo_white_2022.svg
// module id = ZI9U
// module chunks = 0